import React from "react";
import "./TickerInvestimentos.css";

export const TickerInvestimentos = () => {
  // We create 24 layers for a thick 24px coin edge
  const ThickCoin = ({ symbolHtml, coinType, index }) => {
    const edges = Array.from({ length: 24 });
    const angle = index * (360 / 7);
    return (
      <div className={`coin-wrapper`} style={{ '--angle': `${angle}deg` }}>
        <div className={`coin-3d ${coinType}`}>
          <div className="coin-face coin-front" style={{ transform: `translateZ(12px)` }}>
            <div className="coin-inner">
              <span className="coin-symbol" dangerouslySetInnerHTML={{ __html: symbolHtml }}></span>
            </div>
          </div>
          {edges.map((_, i) => (
            <div key={i} className="coin-edge" style={{ transform: `translateZ(${11 - i}px)` }}></div>
          ))}
          <div className="coin-face coin-back" style={{ transform: `translateZ(-12px) rotateY(180deg)` }}>
            <div className="coin-inner">
              <span className="coin-symbol" dangerouslySetInnerHTML={{ __html: symbolHtml }}></span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="monyxx-section">
      <div className="monyxx-content-top">
        <h1 className="revolut-title">
          Tenha o mercado ao vivo,<br />
          atualizado <span className="accent">em tempo real,</span>
        </h1>
        <p className="revolut-sub">
          na sua tela de investimentos.
        </p>

        <a href="#planos" className="revolut-cta">
          Conheça os planos
        </a>
      </div>

      <div className="revolut-coins-container">
        <div className="carousel-track">
          <ThickCoin index={0} coinType="petr" symbolHtml="PETR4" />
          <ThickCoin index={1} coinType="itub" symbolHtml="ITUB4" />
          <ThickCoin index={2} coinType="vale" symbolHtml="VALE3" />
          <ThickCoin index={3} coinType="meta1" symbolHtml="CASA<br/>PRÓPRIA" />
          <ThickCoin index={4} coinType="meta2" symbolHtml="RESERVA<br/>EMERG." />
          <ThickCoin index={5} coinType="meta3" symbolHtml="VIAGEM<br/>2025" />
          <ThickCoin index={6} coinType="btc" symbolHtml="₿" />
        </div>
      </div>
    </section>
  );
};
